/* 🔒 A row's ⋯ menu (T3082; decision 7440): the borderless icon button of a row's pencil, and a short list under it in the panel's own surface. Every value a token. */
.trigger {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--button-height-small);
  height: var(--button-height-small);
  padding: 0;
  border: 0;
  border-radius: var(--radius-small);
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
}

.trigger:hover,
.trigger[aria-expanded='true'] {
  background: var(--surface-2);
  color: var(--navy-primary);
}

.trigger:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.menu {
  position: fixed;
  z-index: 20;
  min-width: calc(var(--space-6) * 5);
  margin: 0;
  padding: var(--space-1);
  list-style: none;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-medium);
  box-shadow: var(--panel-shadow);
}

.entry {
  display: block;
  width: 100%;
  padding: var(--space-2);
  border: 0;
  border-radius: var(--radius-small);
  background: transparent;
  color: var(--text);
  font: inherit;
  font-size: var(--font-size-body);
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}

.entry:hover,
.entry:focus-visible {
  background: var(--surface-2);
}

.entry:focus-visible {
  outline: var(--focus-ring);
}

.separated {
  margin-top: var(--space-1);
  padding-top: var(--space-1);
  border-top: 1px solid var(--surface-2);
}
